var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCharacter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #eee;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24169",
    "data-name": "Group 24169",
    transform: "translate(-154 -423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17895",
    "data-name": "Path 17895",
    className: "cls-1",
    d: "M222,112A110,110,0,1,1,112,2,110,110,0,0,1,222,112ZM139.5,70.75A27.5,27.5,0,1,1,112,43.25a27.5,27.5,0,0,1,27.5,27.5Zm-27.5,55a68.755,68.755,0,0,0-62.513,40.108,82.522,82.522,0,0,0,125.021-.013A68.75,68.75,0,0,0,112,125.75Z",
    transform: "translate(152 421)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacter);
export default __webpack_public_path__ + "static/media/character.7fcb60803a2e980f7beb1b2a82815cd4.svg";
export { ForwardRef as ReactComponent };